/**
 * Created by staffanrantzow on 12/10/16.
 */

import React, { PropTypes } from 'react';
import { proxyCounterpart } from '../../scripts/proxyCounterpart';
import Translate from 'react-translate-component';

export class PayTermsPicker extends React.Component {

  static propTypes = {
    payTerms: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    setPayTerms: PropTypes.func.isRequired,
    renderErrorMessages: PropTypes.bool
  };

  static defaultProps = {
    renderErrorMessages: true
  };

  constructor (props) {
    super(props);

    const payTermsDays = [7, 10, 14, 20, 30, 45, 60, parseInt(props.payTerms)].sort((a, b) => {
      return a - b;
    });
    const uniquePayTermDays = [...new Set(payTermsDays)];
    const payTermsOptions = uniquePayTermDays.map(days => {
      return ({value: `${days} ${proxyCounterpart('DAYS')}`, key: days});
    });

    this.state = {
      options: payTermsOptions,
      selectValue: this.props.payTerms
    };

    this.setPayTerms = this.setPayTerms.bind(this);
  }

  componentDidMount () {
    this.props.setPayTerms(this.state.selectValue);
  }

  setPayTerms (e) {
    this.setState({
      selectValue: e.target.value
    });

    this.props.setPayTerms(e.target.value);
  }

  renderOption (payTerm, i) {
    return (
      <option
        value={payTerm.key}
        key={i}>
        {payTerm.value}
      </option>
    );
  }

  renderPaytermsMessages () {
    if (parseInt(this.props.payTerms) < 30 && this.props.renderErrorMessages) {
      return (
        <p className='info'><Translate content='PAYTERMS_LOW_WARNING'/></p>
      );
    }
    if (parseInt(this.props.payTerms) > 30 && this.props.renderErrorMessages) {
      return (
        <p className='info'><Translate content='PAYTERMS_HIGH_WARNING'/></p>
      );
    }
    return;
  }

  render () {
    return (
      <span className="input-wrapper">
        <div>
          <div className=''>
            <div className='styled-select'>
              <select
                name='pay-terms-picker'
                value={this.state.selectValue}
                onChange={this.setPayTerms}>
                {this.state.options.map(this.renderOption)}
              </select>
              <label htmlFor='pay-terms-picker'><Translate content='PAYTERMS'/></label>
            </div>
          </div>
        </div>
        {this.renderPaytermsMessages()}
      </span>);
  }

}

export default PayTermsPicker;



/** WEBPACK FOOTER **
 ** ./src/components/pay-terms/pay-terms.js
 **/